import { ZROPE_LOGO } from "./logoBase64";
// Shared ZRo Pe PDF brand kit — header/footer bands, palette, helpers.
export const NAVY = [11, 19, 43];
export const NAVY_2 = [16, 27, 58];
export const TEAL = [20, 184, 166];
export const TEAL_DARK = [13, 110, 100];
export const TEAL_LT = [153, 246, 228];
export const GREEN = [16, 185, 129];
export const AMBER = [245, 158, 11];
export const RED = [239, 68, 68];
export const SLATE = [100, 116, 139];

// PDF uses "Rs" (the ₹ glyph is not in the default PDF font)
export const rs = (n) => "Rs " + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export async function loadImage(src) {
  try {
    const res = await fetch(src);
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const r = new FileReader();
      r.onloadend = () => resolve(r.result);
      r.onerror = () => resolve(null);
      r.readAsDataURL(blob);
    });
  } catch { return null; }
}

// Premium navy header band with teal diagonal accent + ZRo Pe brand lockup.
export function drawHeader(doc, { rightTitle, rightSub, mascot }) {
  const W = doc.internal.pageSize.getWidth();
  const h = 96;
  doc.setFillColor(...NAVY);
  doc.rect(0, 0, W, h, "F");
  // layered teal diagonal accents on the right
  doc.setFillColor(...TEAL_DARK);
  doc.triangle(W - 190, 0, W, 0, W, h, "F");
  doc.setFillColor(...TEAL);
  doc.triangle(W - 95, 0, W, 0, W, h, "F");

  // logo tile
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(32, 24, 48, 48, 9, 9, "F");
  if (mascot) doc.addImage(mascot, "PNG", 36, 27, 40, 42);

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(21);
  doc.text("ZRo Pe", 94, 48);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...TEAL_LT);
  doc.text("Simplifying Payments", 95, 63);

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(rightTitle, W - 36, 44, { align: "right" });
  if (rightSub) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(226, 232, 240);
    doc.text(rightSub, W - 36, 60, { align: "right" });
  }
}

// Footer band on the current page.
export function drawFooter(doc, { line1, line2, page, pages, logo }) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const bandH = 50;
  // Official ZRo Pe logo, centered on the white area just above the footer band (natural bg, no box).
  if (logo) {
    const lw = 66, lh = lw / 1.5;
    try { doc.addImage(ZROPE_LOGO, "PNG", (W - lw) / 2, H - bandH - lh - 4, lw, lh); } catch (e) { /* noop */ }
  }
  doc.setFillColor(...NAVY);
  doc.rect(0, H - bandH, W, bandH, "F");
  doc.setFillColor(...TEAL);
  doc.triangle(W - 75, H - bandH, W, H - bandH, W, H, "F");
  if (line1 && !logo) {
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text(line1, 40, H - 29);
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...TEAL_LT);
  doc.text(line2, 40, logo ? H - 20 : H - 15);
  if (page) {
    doc.setTextColor(226, 232, 240);
    doc.setFontSize(8);
    doc.text(`Page ${page} of ${pages}`, W - 36, H - 15, { align: "right" });
  }
}

// Small rounded status pill.
export function drawPill(doc, x, y, text, fg, bg, fontSize = 8) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(fontSize);
  const w = doc.getTextWidth(text) + 16;
  const hh = fontSize + 8;
  doc.setFillColor(bg[0], bg[1], bg[2]);
  doc.roundedRect(x, y, w, hh, hh / 2, hh / 2, "F");
  doc.setTextColor(fg[0], fg[1], fg[2]);
  doc.text(text, x + w / 2, y + hh / 2 + fontSize * 0.36, { align: "center" });
  return w;
}
